export const deliveryResources = {
  fr: {
    compact: {
      client: "Client",
      hu: "HU",
      item: "Article",
      quantity: "Quantité",
      source: "Emplacement source",
      picking: "Référence picking",
      selectGroup: "Sélectionner le groupe {{number}}",
      selectHu: "Sélectionner la HU {{number}}",
      showPicking: "Afficher le picking de la HU {{number}}",
      hidePicking: "Masquer le picking de la HU {{number}}"
    },
    module: "Livraison",
    searchPlaceholder: "Mission, HU, destination…",
    searchWide: "HU, article, ordre de sortie, client, destination, mission ou Trollet",
    tabs: { consolidate: "À consolider", missions: "Missions", repack: "À reconditionner", completed: "Terminées" },
    tabsMobile: { consolidate: "CONSOLIDER", missions: "MISSIONS", repack: "RECONDITIONNER", completed: "TERMINÉES" },
    actions: {
      direct: "Expédier directement", directShort: "Direct", trolley: "Constituer sur un Trollet",
      trolleyMobile: "Constituer Trolley", repack: "Reconditionner", repackShort: "Recond.",
      take: "Prendre en charge", confirmDrop: "Confirmer la dépose", view: "Consulter",
      finish: "Terminer", select: "Sélectionner", create: "Créer", confirmShipment: "Confirmer l’expédition",
      createHuMission: "Créer la HU et la mission", confirmTake: "Confirmer la prise en charge"
    },
    labels: {
      outboundOrder: "Ordre de sortie {{number}}", chooseClient: "Client à choisir",
      chooseDestination: "Destination à choisir", huCount: "{{count}} HU",
      itemCount: "{{count}} article", itemCount_other: "{{count}} articles",
      consolidation: "Consolidation", orderSelected: "Ordre sélectionné", toConsolidate: "À consolider",
      ready: "Prête", originalHu: "HU d’origine", deliveryStep: "Livraison {{number}}",
      transferRequired: "TRANSFERT REQUIS", open: "OUVERTE", inProgress: "EN COURS",
      physicalTrolley: "Trollet physique", capacity: "capacité {{capacity}}",
      destinationPou: "POU de destination", destination: "Destination", pou: "POU",
      postalAddress: "Adresse postale", repackingStation: "Gare de reconditionnement",
      targetPackaging: "Conditionnement cible", priority: "Priorité",
      scannedHu: "HU scannées ({{count}} attendue)", scannedHu_other: "HU scannées ({{count}} attendues)",
      sourceHu: "HU sources ({{count}})", missionDetails: "Détail de la mission",
      documents: "Documents", documentsCount: "Documents ({{count}})"
    },
    dialogs: {
      createTrolley: "Choisir le Trollet et créer la mission", createRepack: "Créer le reconditionnement de sortie",
      createDirect: "Créer une expédition directe", confirmPou: "Confirmer la livraison au POU",
      confirmShipment: "Confirmer l’expédition", finishRepack: "Terminer le reconditionnement de sortie",
      takeMission: "Prendre en charge la mission"
    },
    help: {
      trolleySelection: "{{count}} HU seront chargées sur le Trollet physique choisi à la gare {{station}}.",
      repackSelection: "{{count}} HU seront reconditionnées avant livraison depuis {{station}}.",
      directSelection: "{{count}} HU d’origine seront conservées et expédiées depuis {{station}}.",
      chooseTrolley: "Choisissez un Trollet ou scannez/saisissez son identifiant.",
      noTrolley: "Aucun Trollet physique disponible. Libérez un Trollet ou vérifiez les engins de manutention.",
      scanTrolleyPou: "Scannez le Trollet utilisé puis le POU pour confirmer la dépose physique.",
      scanNewHu: "Scannez la nouvelle HU d’expédition avant de confirmer.",
      scanOriginalHu: "Scannez chaque HU d’origine, une par ligne, avant de confirmer.",
      repackScan: "Scannez toutes les HU sources. Une nouvelle HU d’expédition sera générée dans le conditionnement {{packaging}}."
    },
    scan: { trolley: "Scanner le Trollet", pou: "Scanner le POU" },
    empty: {
      consolidation: "Aucune préparation terminée n’attend de consolidation.",
      missions: "Aucune mission dans cette liste.", documents: "Aucun document généré pour cette mission."
    },
    errors: {
      load: "Impossible de charger le flux de livraison.", reserveTrolley: "La réservation du Trollet et la création de la mission ont échoué.",
      createRepack: "La création du reconditionnement a échoué.", createDirect: "La création de l’expédition directe a échoué.",
      confirmation: "La confirmation a échoué. Vérifiez les identifiants scannés.",
      completeRepack: "Le reconditionnement n’a pas pu être terminé.", documentOpen: "Ouverture du document impossible.",
      documents: "Historique documentaire indisponible."
    },
    document: { loading: "Chargement…" },
    aria: { details: "Afficher le détail" },
    diagnostics: { confirm: "Confirmation de la livraison", take: "Prise en charge de la mission", create: "Création d’une mission", tab: "Onglet {{tab}}" }
  },
  en: {
    compact: {
      client: "Customer",
      hu: "HU",
      item: "Material",
      quantity: "Quantity",
      source: "Source location",
      picking: "Picking reference",
      selectGroup: "Select group {{number}}",
      selectHu: "Select HU {{number}}",
      showPicking: "Show picking for HU {{number}}",
      hidePicking: "Hide picking for HU {{number}}"
    },
    module: "Delivery",
    searchPlaceholder: "Mission, HU, destination…",
    searchWide: "HU, material, outbound order, customer, destination, mission or Trolley",
    tabs: { consolidate: "To consolidate", missions: "Missions", repack: "To repack", completed: "Completed" },
    tabsMobile: { consolidate: "CONSOLIDATE", missions: "MISSIONS", repack: "REPACK", completed: "COMPLETED" },
    actions: {
      direct: "Direct Shipping", directShort: "Direct", trolley: "Group on Trolley",
      trolleyMobile: "Group Trolley", repack: "Repack", repackShort: "Repack",
      take: "Take over", confirmDrop: "Confirm drop-off", view: "View", finish: "Finish",
      select: "Select", create: "Create", confirmShipment: "Confirm shipment",
      createHuMission: "Create HU and mission", confirmTake: "Confirm take-over"
    },
    labels: {
      outboundOrder: "Outbound order {{number}}", chooseClient: "Customer to select",
      chooseDestination: "Destination to select", huCount: "{{count}} HU",
      itemCount: "{{count}} material", itemCount_other: "{{count}} materials",
      consolidation: "Consolidation", orderSelected: "Order selected", toConsolidate: "To consolidate",
      ready: "Ready", originalHu: "Original HU", deliveryStep: "Delivery {{number}}",
      transferRequired: "TRANSFER REQUIRED", open: "OPEN", inProgress: "IN PROGRESS",
      physicalTrolley: "Physical Trolley", capacity: "capacity {{capacity}}",
      destinationPou: "Destination POU", destination: "Destination", pou: "POU",
      postalAddress: "Postal address", repackingStation: "Repacking station",
      targetPackaging: "Target packaging", priority: "Priority",
      scannedHu: "Scanned HU ({{count}} expected)", scannedHu_other: "Scanned HUs ({{count}} expected)",
      sourceHu: "Source HUs ({{count}})", missionDetails: "Mission details",
      documents: "Documents", documentsCount: "Documents ({{count}})"
    },
    dialogs: {
      createTrolley: "Select the Trolley and create the mission", createRepack: "Create outbound repacking",
      createDirect: "Create a direct shipment", confirmPou: "Confirm delivery to the POU",
      confirmShipment: "Confirm shipment", finishRepack: "Complete outbound repacking",
      takeMission: "Take over the mission"
    },
    help: {
      trolleySelection: "{{count}} HU will be loaded onto the selected physical Trolley at station {{station}}.",
      repackSelection: "{{count}} HU will be repacked before delivery from {{station}}.",
      directSelection: "{{count}} original HU will be retained and shipped from {{station}}.",
      chooseTrolley: "Select a Trolley or scan/enter its identifier.",
      noTrolley: "No physical Trolley is available. Release a Trolley or check handling equipment.",
      scanTrolleyPou: "Scan the Trolley used, then the POU, to confirm the physical drop-off.",
      scanNewHu: "Scan the new shipping HU before confirming.",
      scanOriginalHu: "Scan each original HU, one per line, before confirming.",
      repackScan: "Scan all source HUs. A new shipping HU will be generated using packaging {{packaging}}."
    },
    scan: { trolley: "Scan Trolley", pou: "Scan POU" },
    empty: { consolidation: "No completed preparation is awaiting consolidation.", missions: "No mission in this list.", documents: "No document generated for this mission." },
    errors: {
      load: "Unable to load the delivery flow.", reserveTrolley: "The Trolley reservation and mission creation failed.",
      createRepack: "Unable to create repacking.", createDirect: "Unable to create the direct shipment.",
      confirmation: "Confirmation failed. Check the scanned identifiers.", completeRepack: "Unable to complete repacking.",
      documentOpen: "Unable to open the document.", documents: "Document history is unavailable."
    },
    document: { loading: "Loading…" }, aria: { details: "Show details" },
    diagnostics: { confirm: "Delivery confirmation", take: "Mission take-over", create: "Mission creation", tab: "Tab {{tab}}" }
  }
} as const;
